/**
 * Sprint API Documentation
 * Sprint API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: developer@sprintapp.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ComplaintType = 'Food' | 'FoodCardIntake' | 'FoodCardIntakeItem' | 'Supplement';

export const ComplaintType = {
    Food: 'Food' as ComplaintType,
    FoodCardIntake: 'FoodCardIntake' as ComplaintType,
    FoodCardIntakeItem: 'FoodCardIntakeItem' as ComplaintType,
    Supplement: 'Supplement' as ComplaintType
};

